module.exports = __webpack_public_path__ + "static/media/model13.9b996afe.glb";